/* eslint-disable @nx/enforce-module-boundaries */
import type { AImageProps } from '@marriott/mi-web-ui-kit';
import type { AEyebrowVariant } from '@marriott/mi-web-ui-kit';
import type { AHeaderSize, AHeaderTag } from '@marriott/mi-web-ui-kit';
import type { ABodyColor, ABodySize } from '@marriott/mi-web-ui-kit';

export enum OChatAlignment {
  Center = 'center',
  Left = 'left',
}

export interface OChatTextBlockSimpleProps {
  alignment?: OChatAlignment;
  aEyebrow?: {
    eyebrowText?: string;
    eyebrowVariant?: AEyebrowVariant;
  };
  aHeader?: {
    text: string;
    size?: AHeaderSize;
    element?: AHeaderTag;
  };
  aBody?: {
    bodyText: string;
    size?: ABodySize;
    color?: ABodyColor;
  };
}

export interface OChatFieldChatProps {
  aInputText?: {
    text?: string;
  };
  aIcon?: {
    icon?: string;
    size?: string;
  };
  // Messaging functionality props
  inputValue?: string;
  onInputChange?: (value: string) => void;
  onSendMessage?: () => void;
  onCancelRequest?: () => void;
  isLoading?: boolean;
  isProcessing?: boolean;
  maxLength?: number;
}

export interface OChatChipProps {
  aBody: {
    bodyText: string;
    size?: ABodySize;
    color?: ABodyColor;
  };
  aBody2: {
    bodyText?: string;
    size?: ABodySize;
    color?: ABodyColor;
  };
}

export interface OChatChipGroupProps {
  mQuickSelectChipMulti?: OChatChipProps[];
}

export interface OChatParagraphProps {
  aBody: {
    enabled?: boolean;
    bodyText?: string;
  };
}

export interface OChatProps {
  componentId?: string;
  aImage?: AImageProps;
  /** Wide preview hero for empty-state preview panel (`:Wide-Ver` applied in code). */
  aImage2?: AImageProps;
  mTextBlockSimple?: OChatTextBlockSimpleProps;
  mFieldChat?: OChatFieldChatProps;
  mChipGroup?: OChatChipGroupProps;
  /** Welcome-screen disclaimer copy (dismissible mobile card, desktop footer). */
  mParagraph?: OChatParagraphProps;
  /** Active-chat disclaimer copy (mobile top bar, inline messages, under input). */
  mParagraph2?: OChatParagraphProps;
  className?: string;
  /** Base URL for the TIP SSE orchestrator. Defaults to dev environment. */
  sseBaseUrl?: string;
  /** AEM model for the MiniSearchBar (dates / rooms / rate pill) shown in map & list views */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  miniSearchBarModel?: Record<string, any>;
}

export const TEST_ID = 'mi-chat-components-OChat';
